<template>
  <PageHeader :title="$t('Sellers')">
    <CreateButton @click="isSellerCreationOpen = true">{{ $t("AddSeller") }}</CreateButton>
  </PageHeader>
  <SearchToolbar
    class="mb-6"
    :placeholder="$t('SearchSellers')"
    :initial-keywords="keywords"
    :available-filters="{}"
    :selected-filters="{}"
    @update-keyword-search="updateKeywordSearch"
  />
  <Table
    :columns="columns"
    :data="index"
    :isDeletable="allowedToDeleteSeller"
    :isUpdatable="allowedToUpdateSeller"
    @delete="deleteSeller"
    @update="
      (row) => {
        selectedSellerToUpdate = row;
      }
    "
  />
  <Pagination
    :currentPage="currentPage"
    :totalPages="totalPages"
    :totalCount="totalCount"
    @changePage="handleChangePage"
  />
  <SellerCreation :isOpen="isSellerCreationOpen" @closeSellerCreation="closeSellerCreation" @getSellers="getSellers" />
  <SellerUpdate
    :is-open="selectedSellerToUpdate !== null"
    :selected-seller="selectedSellerToUpdate"
    @closeSellerUpdate="closeSellerUpdate"
    @getSellers="getSellers"
  />
</template>

<script>
import SellerCreation from "@/views/pos/seller/SellerCreation.vue";

import { mapActions, mapGetters, mapState } from "vuex";
import { CreateButton, PageHeader, Pagination, SearchToolbar, Table } from "@estaly/ui";
import SellerUpdate from "@/views/pos/seller/SellerUpdate.vue";

export default {
  components: {
    SellerUpdate,
    CreateButton,
    PageHeader,
    SearchToolbar,
    SellerCreation,
    Pagination,
    Table,
  },

  data() {
    return {
      currentPage: 1,
      keywords: "",
      isSellerCreationOpen: false,
      selectedSellerToUpdate: null,
    };
  },

  mounted() {
    this.getSellers();
    if (this.$route.params.openSellerCreation) this.isSellerCreationOpen = true;
    // Vérifier le query param pour ouvrir la modal d'ajout
    if (this.$route.query.action === "add") {
      this.isSellerCreationOpen = true;
      // Nettoyer le paramètre après utilisation
      this.$router.replace({
        query: { ...this.$route.query, action: undefined },
      });
    }
  },

  watch: {
    keywords() {
      this.currentPage = 1;
      this.getSellers();
    },
    currentPage() {
      this.getSellers();
    },
    "$route.query.action": {
      handler(action) {
        if (action === "add") {
          this.isSellerCreationOpen = true;
          // Nettoyer le paramètre après utilisation
          this.$router.replace({
            query: { ...this.$route.query, action: undefined },
          });
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapGetters("auth", ["hasAccessToAdminDashboard", "isResponsible"]),
    ...mapState("sellers", ["index", "totalPages", "totalCount"]),
    columns() {
      return [
        { label: this.$t("First name"), field: "firstName" },
        { label: this.$t("Last name"), field: "lastName" },
      ];
    },

    allowedToDeleteSeller() {
      return this.hasAccessToAdminDashboard || this.isResponsible;
    },

    allowedToUpdateSeller() {
      return this.hasAccessToAdminDashboard || this.isResponsible;
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("sellers", ["fetchIndex", "delete"]),

    handleChangePage(page) {
      this.currentPage = page;
    },

    updateKeywordSearch(search) {
      this.keywords = search;
    },

    closeSellerCreation() {
      this.isSellerCreationOpen = false;
    },

    closeSellerUpdate() {
      this.selectedSellerToUpdate = null;
    },

    async getSellers() {
      await this.fetchIndex({
        storeId: this.selectedStoreId,
        keywords: this.keywords,
        page: this.currentPage,
      });
    },

    async deleteSeller(seller) {
      if (!confirm("Supprimer ce vendeur ?")) return;

      const response = await this.delete(seller.id);
      if (!response?.success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Vendeur supprimé",
      });
      this.getSellers();
    },
  },
};
</script>
